<template>
  <div></div>
</template>
<script>
    export default {
        name: "Navbar"
    }
</script>
